import { Product } from "./products/all";

export const RoutePutInputsProducts = "/inputs/products";

export interface PayloadPutInputsProducts {
  products: Product[];
}
